import type { CSSProperties } from 'react';
import AvatarIcon from './AvatarIcon';

interface ChatHeaderProps {
  onReset: () => void;
  disabled?: boolean;
}

const styles: Record<string, CSSProperties> = {
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '16px 16px 18px',
    background: 'linear-gradient(90deg, #E84A00 0%, #FF5F05 45%, #FF8A00 100%)',
    color: '#FFFFFF',
    flexShrink: 0,
  },
  brandMark: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  textBlock: {
    flex: 1,
    minWidth: 0,
  },
  title: {
    margin: 0,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: '-0.01em',
    lineHeight: 1.25,
  },
  subtitle: {
    margin: '2px 0 0',
    fontSize: 12,
    fontWeight: 400,
    opacity: 0.92,
    lineHeight: 1.3,
  },
  resetBtn: {
    width: 36,
    height: 36,
    borderRadius: '50%',
    border: 'none',
    background: 'rgba(255,255,255,0.18)',
    color: '#FFFFFF',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    transition: 'background 0.15s ease',
  },
};

function RefreshIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M20 12a8 8 0 1 1-2.34-5.66"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20 4v5h-5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function ChatHeader({ onReset, disabled }: ChatHeaderProps) {
  return (
    <header style={styles.header}>
      {/* Web chat panel: white mark on orange header (matches design mock) */}
      <div style={styles.brandMark}>
        <AvatarIcon variant="white" size={40} alt="Avatar" />
      </div>
      <div style={styles.textBlock}>
        <h1 style={styles.title}>Chat with Avatar</h1>
        <p style={styles.subtitle}>Ask, discover, or get help instantly</p>
      </div>
      <button
        type="button"
        style={{
          ...styles.resetBtn,
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={onReset}
        disabled={disabled}
        aria-label="Reset conversation"
        title="Reset conversation"
      >
        <RefreshIcon />
      </button>
    </header>
  );
}
